import styled from 'styled-components';
import { AttentionAccidentTable } from '../../../../../../components/display/tables/formTables/AttentionAccidentTable';
import { MainButton } from '../../../../../../components/inputs/buttons/MainButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.xl};
  flex: 1;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xl};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const SubContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl};
  flex: 1;
`;

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => theme.spacing.xl};
  background: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS */
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs};
`;

export const AttentionAccidentTableStyled = styled(AttentionAccidentTable)`
  max-width: 100%;
`;

export const MainButtonStyled = styled(MainButton)`
  align-self: end;
`;
